// Taken from https://gist.github.com/1290439
/* You can now create a spinner using any of the variants below:

$("#el").spin(); // Produces default Spinner using the text color of #el.
$("#el").spin("small"); // Produces a 'small' Spinner using the text color of #el.
$("#el").spin("large", "white"); // Produces a 'large' Spinner in white (or any valid CSS color).
$("#el").spin({ ... }); // Produces a Spinner using your custom settings.
$("#el").spin(false); // Kills the spinner.

*/
(function($) {
	$.fn.spin = function(opts, color) {
		var presets = {
			"tiny": { lines: 8, length: 2, width: 2, radius: 3 },
			"small": { lines: 8, length: 4, width: 3, radius: 5 },
			"large": { lines: 10, length: 16, width: 8, radius: 18 }
		};

		if (Spinner) {
			return this.each(function() {
				var $this = $(this),
					data = $this.data();

				if (data.spinner) {
					data.spinner.stop();
					delete data.spinner;
				}
				if (opts !== false) {
					if (typeof opts === "string") {
						if (opts in presets) {
							opts = presets[opts];
						} else {
							opts = {};
						}
						if (color) {
							opts.color = color;
						}
					}
					data.spinner = new Spinner($.extend({color: $this.css('color')}, opts)).spin(this);
				}
			});
		} else {
			throw "Spinner class not available.";
		}
	};
})(jQuery);

start_spin = function (_target) {
    if (!_target) {
        _target = '#content';
    }
    $(_target).spin('large', '#000');
};

end_spin = function (_target) {
    if (!_target) {
        _target = '#content';
    }
    $(_target).spin(false);
};

//nice prompt
prompt_line = function (_message, _callback, _options) {
    prompt_nice(_message, _callback, _.extend({ rows: 1, cols: 80 }, _options));
};

prompt_small = function (_message, _callback, _options) {
    prompt_nice(_message, _callback, _.extend({ rows: 1, cols: 10 }, _options));
};

prompt_nice = function (_message, _callback, _options) {
    var options = _.extend({ rows: 5, cols: 80, default: '', id: 'nice_prompt_text' }, _options || {});

    $(document.createElement('div'))
        .html("<p>" + _message + "</p><br />" +
              (options['rows'] == 1
                  ? "<input type='text' size='" + options['cols'] + "' id='" + options['id'] + "' value='" + options['default'] + "' />"
                  : "<textarea rows='" + options['rows'] + "' cols='" + options['cols'] + "' id='" + options['id'] + "' />" + options['default'] + '</textarea>'))
        .dialog({
            buttons: [
                { text: _T('cancel'), class: 'warning', click: function() { $(this).dialog('close'); } },
                { text: _T('ok'),
                  click: function() {
                              _callback($(this).find('#' + options['id']).val());
                              $(this).dialog('close');
                          }}],
            open: function() {
                if (options['default']) {
                    $(this).find('#' + options['id']).val(options['default']);
                }
            },
            close: function() { $(this).remove(); },
            draggable: true,
            modal: true,
            resizable: false,
            width: 'auto'
        });
};

// post-render functions

renderAddButton = function () {
    if(!$(this).hasClass('post-rendered-applied'))   {
        $(this).addClass("post-rendered-applied");
        var button = $('<button class="add">' + $(this).attr("value") + '</button>');

        if ($(this).attr("id")) button.attr('id', 'button_' + $(this).attr("id"));
        if ($(this).attr("name")) button.attr('name', 'button_' + $(this).attr("name"));

        button.button({icons:{primary:'ui-icon-circle-plus'} });

        var myclick, clicks = $._data($(this).get(0), "events").click;
        $.each(clicks, function (i, f) {
            myclick = f;
            return false;
        });
        button.click(myclick);

        $(this).after(button);
        $(this).hide();
    }
};

reRenderSelector = function () {
    var element = $(this);

    element.removeClass("post-rendered-applied");

    $('#' + element.attr('id') + '_rendered').remove();

    element.each(renderSelector);
};

renderSelector = function () {
    var element = $(this);
    if(!element.hasClass('post-rendered-applied'))   {
        element.addClass("post-rendered-applied");

        element.addClass("ui-helper-hidden");
        element.hide();

        var parent = $('<div id="' + element.attr('id') + '_rendered" class="hover std-selector ui-state-default jquery-render-selector"></div>');

        var labeltext = $("<span class='std-label'></span>");

        labeltext.html($(element.find("option")[0]).html());
        labeltext.html($(element.find("option:selected")[0]).html());

        var ico =  $("<span style='float:right;display:inline-block' class='ui-icon ui-icon-triangle-1-s' ></span>");
        var ul = $("<ul class='ui-helper-reset ui-widget-content ui-helper-hidden' style='margin-top:2em;position:absolute;z-index:50;min-width:180px;min-height:100px;max-height:14.5rem;overflow:auto' ></ul>");

        $.each(element.find("option"),function(){
            var li = $("<li name='"+$(this).val()+"' class='hover' style='padding:0.25rem;border-bottom:1px solid #eee'>"+$(this).html()+"</li>");
            li.click(function(event){
                labeltext.html($(this).html());
                element.val($(this).attr('name')).change();
                $(this).parent().removeClass('std-selector-opened');
                $(this).parent().hide();
                event.stopPropagation();
            });
            ul.append(li);
        });

        parent.click(function(event){
            if (ul.is(":hidden")) {
                parent.addClass('std-selector-opened');
                ico.removeClass('ui-icon-triangle-1-s');
                ico.addClass('ui-icon-triangle-1-n');

            } else {
                parent.removeClass('std-selector-opened');
                ico.removeClass('ui-icon-triangle-1-n');
                ico.addClass('ui-icon-triangle-1-s');
            }
            ul.toggle();
            event.preventDefault();
            event.stopPropagation();
        });

        element.after(parent);

        parent.append(labeltext);
        parent.append(ico);
        parent.append(ul);
    }
};

reRenderReleaseSelector = function () {
    var element = $(this);

    element.removeClass("post-rendered-applied");

    $('#' + element.attr('id') + '_rendered').remove();

    element.each(renderReleaseSelector);
};

renderReleaseSelector = function () {
    var element = $(this);
    if(!element.hasClass('post-rendered-applied'))   {
        element.addClass("post-rendered-applied");

        element.addClass("ui-helper-hidden");
        element.hide();

        var parent = $('<div id="' + element.attr('id') + '_rendered" tabindex="0" class="hover std-selector ui-state-default jquery-render-selector col-3 input__box input--select"></div>');

        var labeltext = $("<span></span>");

        labeltext.html($(element.find("option")[0]).html());
        labeltext.html($(element.find("option:selected")[0]).html());

        var ico =  $("<span style='float:right;display:inline-block' class='ui-icon icon--chevron chevron--down' ></span>");
        var ul = $("<ul class='input--select__dropdown' style='display: none' ></ul>");

        $.each(element.find("option"),function(){
            var li = $("<li name='"+$(this).val()+"' class='input--select__dropdown--item'>"+$(this).html()+"</li>");
            li.click(function(event){
                labeltext.html($(this).html());
                element.val($(this).attr('name')).change();
                $(this).parent().removeClass('std-selector-opened');
                $(this).parent().hide();
                event.stopPropagation();
            });
            ul.append(li);
        });

        parent.click(function(event){
            if (ul.is(":hidden")) {
                parent.addClass('std-selector-opened');
                ul.css('display: block;')
                ico.removeClass('chevron--down');
                ico.addClass('chevron--rotated');

            } else {
                parent.removeClass('std-selector-opened');
                ul.css('display: none;')
                ico.removeClass('chevron--rotated');
                ico.addClass('chevron--down');
            }
            ul.toggle();
            event.preventDefault();
            event.stopPropagation();
        });

        element.after(parent);

        parent.append(labeltext);
        parent.append(ico);
        parent.append(ul);
    }
};

var postRenderInt;

postRender = function  () {
    postRenderInt = window.clearInterval(postRenderInt);

    $(".std-button:not(.ui-state-disabled)")
        .hover(
        function () {
            $(this).addClass("ui-state-hover");
        },
        function () {
            $(this).removeClass("ui-state-hover");
        }
    )
        .mousedown(function () {
            $(this).parents('.std-buttonset-single:first').find(".std-button.ui-state-active").removeClass("ui-state-active");
            if ($(this).is('.ui-state-active .std-button-toggleable, .std-buttonset-multi .ui-state-active')) {
                $(this).removeClass("ui-state-active");
            }
            else {
                $(this).addClass("ui-state-active");
            }
        })
        .mouseup(function () {
            if (!$(this).is('.std-button-toggleable, .std-buttonset-single .std-button,  .std-buttonset-multi .std-button')) {
                $(this).removeClass("ui-state-active");
            }
        });


    $("button:not([data-phoenix]), input[type='button']:not([data-phoenix]), input[type='submit']:not([data-phoenix])").button();
    $('input:text, input:password, input[type=email]').addClass('std-input std-textfield');
    $(".cform input").removeClass('std-input std-textfield');

    $("input[data-add]").each(renderAddButton);

    $("select:not(.release-select, .no-render)").each(renderSelector);

    $(".release-select").each(renderReleaseSelector);

    $("button[id*='upload']").addClass('upload').button('destroy').button({icons: {primary:'ui-icon-upload'} });

    /* TODO toggle icons
     $("input[type='checkbox'] ~ label").each(function (){
     $(this).prev().button().addClass('std-checkbox');
     });
     */

    $(document).on('mouseenter', '.hover', function() { $(this).addClass("ui-state-hover"); })
        .on('mouseleave', '.hover', function() { $(this).removeClass("ui-state-hover"); });

    $(".disabled_action, .disabled").attr("disabled", "disabled").css('cursor', 'default').hover(function(){
        $(this).removeClass("ui-state-hover");},function(){$(this).removeClass("ui-state-hover");
    });

    $(window).click(function() {
        $('.std-selector-opened ul').hide();
        $('.std-selector-opened span:nth-child(2)').removeClass('ui-icon-triangle-1-n');
        $('.std-selector-opened span:nth-child(2)').addClass('ui-icon-triangle-1-s');
        $('.std-selector-opened span:nth-child(2)').removeClass('chevron--rotated');
        $('.std-selector-opened span:nth-child(2)').addClass('chevron--down');
        $('.std-selector-opened').removeClass('std-selector-opened');
    });

    $.expr[':'].icontains = function(obj, index, meta, stack){
        return (obj.textContent || obj.innerText || $(obj).text() || '').toLowerCase().indexOf(meta[3].toLowerCase()) >= 0;
    };

    $(window).keydown(function(e) {
        if($('.std-selector-opened').length ) {
            var key = String.fromCharCode(e.which);

            if(key.match(/\d|\w/)){
                bufferSelector+=key;
                var liSelected = $('.std-selector-opened ul li:icontains('+bufferSelector+')').first();
                var html = liSelected.html();
                if(html) {
                    $('.std-selector-opened ul li').removeClass('ui-state-hover');
                    liSelected.addClass('ui-state-hover');
                    $('.std-selector-opened ul').scrollTop(0);
                    $('.std-selector-opened ul').scrollTop(liSelected.position().top);
                }
            }
            window.clearInterval(selectorInt);
            selectorInt = window.setInterval(function () {
                cleanBufferSelector();
            }, 1000);
        }
    });

    appendIconsToUserEmails();
};

appendIconsToUserEmails = function () {

    $('.user_login').not('.shortcut_enhanced')
        .addClass('shortcut_enhanced')
        .append(function() {
            var email = $(this).text();
            return $("\
<a href='mailto:" + email + "'><span class='ui-icon ui-icon-mail-closed' style='display:inline-block' /></a>\
<a class ='login_as_user' data-user_email='" + email + "' href='#'><span class='ui-icon ui-icon-key' style='display:inline-block' /></a>\
");
        });

    $('.user_login.blocked_user a').css('color', 'red');
};

$(document).ready(function () {

    $(document).on('pager:page', '.pager', function() {
        appendIconsToUserEmails();
    });

    $(document).on('click', '.login_as_user', function() {
        loginAsUser($(this).data('user_email'));
    });
});

var bufferSelector='', selectorInt;

cleanBufferSelector = function (){
    selectorInt = window.clearInterval(selectorInt);
    bufferSelector='';
};

$(document).ready(function () {

    postRenderInt = window.setInterval(function () {
        postRender();
    }, 100);

});

dutType = function (type) {
    var retType = "-";
    switch(type) {
        case "d": retType = "Delivery"; break;
        case "t": retType = "Takedown"; break;
        case "u": retType = "Update";   break;
    }
    return _T(retType);
};
